const tags = (data) => {
    let resultsHTML = ''
    if (data.tags) {
        data.tags.map((service) => {
            resultsHTML += `
                <span class="tag tag--shape-curved tag--cornflower">
                    ${service}
                </span>
            `
        })
    }
    return resultsHTML
}

const image = (data) => {
    if (data.logoSrc) {
        return `<figure class="card__main-media">
            <div class="card__main-img" style="background-image: url(${data.logoSrc}); background-position: center center; background-repeat: no-repeat; background-size: contain;"></div>
            </figure>`
    } else {
        return ''
    }
}

// prettier-ignore
const template = (data, extraClass = '') => {

    return `<div class="grid__item">
        <a href="${data.link}" class="card card--logo__alt ${extraClass} card--link">
            <article class='card__body'>
                <div class='card__main'>
                    ${image(data)}
                    <div class='card__header'>
                        <h3 class='card__heading'>
                            ${data.name}
                        </h3>
                    </div>
                    <div class='card__copy'>
                        <p class='u-mb-half'>${data.location !== null ? `<div class="card__copy"><p>${data.location}</p></div>` : ''}</p>
                        <div class="tags">
                            ${tags(data)}
                        </div>
                    </div>
                    <div class='card__bottom'>
                        <div class='card__header'>
                            <h3 class='card__heading'>
                                ${data.name}
                            </h3>
                        </div>
                        <div class='card__copy'>
                            <p class='u-mb'>${data.location !== null ? `<div class="card__copy"><p>${data.location}</p></div>` : ''}</p>
                            <p class='u-mb'>${data.description}</p>
                        </div>
                    </div>
                </div>
            </article>
        </a>
    </div>`
}
export default template
